import { useEffect, useState } from "react";
import { getBuildersApi,getInactiveBuildersApi, createBuilderApi, updateBuilderApi, deleteBuilderApi, reactivateBuilderApi, } from "../apiServices/builderServices";

const useBuilders = (params = {}) => {
  const [builders, setBuilders] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchBuilders = async () => {
    try {
        setLoading(true);

        let res;

        if (params?.status === "inactive") {
        res = await getInactiveBuildersApi(params);
        } else {
        res = await getBuildersApi(params);
        }

        const data = res?.data || res;

        setBuilders(data?.builders || []);
        setPagination({
        page: data?.page || 1,
        totalPages: data?.totalPages || 1,
        total: data?.total || 0,
        });
    } catch (err) {
        console.error(err);
    } finally {
        setLoading(false);
    }
    };

  const createBuilder = async (data) => {
    await createBuilderApi(data);
    fetchBuilders();
  };

  const updateBuilder = async (id, data) => {
    await updateBuilderApi(id, data);
    fetchBuilders();
  };

  const deleteBuilder = async (id) => {
    await deleteBuilderApi(id);
    fetchBuilders();
  };

  const reactivateBuilder = async (id) => {
    await reactivateBuilderApi(id);
    fetchBuilders();
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchBuilders();
    }, 400);

    return () => clearTimeout(delay);
  }, [JSON.stringify(params)]);

  return { builders, pagination, loading, fetchBuilders, createBuilder, updateBuilder, deleteBuilder, reactivateBuilder, };
};

export default useBuilders;